import { TargetsProvider } from "./TargetsContext.js";
import Targets from "./Targets.js";

const TargetsIndex = () => {
  return (
    <TargetsProvider>
      <Targets />
    </TargetsProvider>
  );
};
export default TargetsIndex;
